module.exports = __webpack_public_path__ + "img/jpg.39578364.png";